<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vx-card class="mt-base">
            <div class="w-full flex flex-col">
              <div class="w-full relative">
                <div class="flex w-full  justify-between items-center">
                  <div class="text-xl flex-1 flex flex-col ">
                    <div class="font-semibold">Detail Hak Akses</div>
                  </div>
                  <div class="flex">
                    <div
                      class="flex items-center cursor-pointer shadow px-4 py-2 rounded-lg mx-3"
                      @click="$refs.dialogUpdate.toggleActive(true)"
                    >
                      <feather-icon icon="EditIcon" class="mr-3"></feather-icon>
                      <div>Update Hak Akses</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5">
              <h6>Nama Hak Akses :</h6>
              <p>{{ hakAkses.name }}</p>
            </div>
            <div class="mt-5">
              <h6>Tipe Akses :</h6>
              <p>{{ hakAkses.tipe_akses }}</p>
            </div>
            <div class="mt-5">
              <h6>URL :</h6>
              <p>{{ hakAkses.url }}</p>
            </div>
            <div class="mt-5">
              <h6>Icon :</h6>
              <p>{{ hakAkses.icon }}</p>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <br />
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vx-card class="mt-base">
            <div class="w-full flex flex-col">
              <div class="w-full relative">
                <div class="flex w-full  justify-between items-center">
                  <div class="text-xl flex-1 flex flex-col ">
                    <div class="font-semibold">
                      List Pengguna {{ hakAkses.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <vs-tabs>
              <vs-tab
                label="Pengguna Hak Akses"
                icon-pack="feather"
                icon="icon-user"
              >
                <div class="w-full flex justify-end">
                  <global-wrapper
                    :loading="$apollo.queries.hakAksesPengguna.loading"
                    :loadingType="'OneLine'"
                    :loadingList="5"
                    :empty="hakAksesPengguna.data <= 0"
                  >
                    <global-table
                      @reloadData="refetchHakAksesPengguna($event)"
                      :currentPage="pagination.page"
                      :totalPage="hakAksesPengguna.paginatorInfo.lastPage"
                    >
                      <template #thead>
                        <global-th>No</global-th>
                        <global-th>Nama</global-th>
                        <global-th>Jabatan</global-th>
                        <global-th>Action</global-th>
                      </template>
                      <template #tbody>
                        <global-tr
                          v-for="(item, index) in hakAksesPengguna.data"
                          :key="index"
                        >
                          <global-td width="20px" left="0" class="sticky-col">
                            {{
                              Math.ceil(
                                (hakAksesPengguna.paginatorInfo.currentPage -
                                  1) *
                                  hakAksesPengguna.paginatorInfo.perPage +
                                  index +
                                  1
                              )
                            }}
                          </global-td>
                          <global-td>
                            {{ item.pengguna.nama }}
                          </global-td>
                          <global-td>{{
                            item.pengguna.jabatan.nama
                          }}</global-td>
                          <global-td>
                            <div class="vx-row">
                              <vs-button
                                @click="
                                  $router.push({
                                    name: 'manajemen-user-detail',
                                    params: { uuid: item.pengguna.uuid }
                                  })
                                "
                                color="primary"
                                size="small"
                                class="m-1"
                                type="border"
                                icon-pack="feather"
                                icon="icon-eye"
                                >Lihat Pegawai</vs-button
                              >
                            </div>
                          </global-td>
                        </global-tr>
                      </template>
                    </global-table>
                  </global-wrapper>
                </div>
              </vs-tab>
            </vs-tabs>
          </vx-card>
        </div>
      </div>
    </div>
    <br />
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
          @click="$router.push({ name: 'hak-akses' })"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="mb-4 self-end"
          size="small"
        >
          Kembali
        </vs-button>
      </div>
    </div>
    <DialogUpdate
      ref="dialogUpdate"
      :hakAkses="hakAkses"
      @submitCallback="refetchHakAkses(1)"
    />
    <DialogUpdateChild
      ref="dialogUpdateChild"
      :hakAkses="selectedChildData"
      @submitCallback="refetchHakAkses(1)"
    />
  </div>
</template>

<script>
import { FIND } from "@/query/hak-akses";
import { GET_ALL } from "@/query/hak-akses-pengguna";
import DialogUpdate from "./DialogUpdate";
import DialogUpdateChild from "./DialogUpdateChild";

export default {
  components: {
    DialogUpdate,
    DialogUpdateChild
  },
  data() {
    return {
      hakAkses: {
        name: "",
        url: "",
        tipe_akses: "",
        icon: "",
        child: []
      },
      selectedChildData: {},
      defaultHakAksesId: 1,
      hakAksesPengguna: {
        data: [],
        paginatorInfo: {
          lastPage: 1,
          currentPage: 1
        }
      },
      pagination: {
        page: 1,
        perPage: 10
      }
    };
  },
  apollo: {
    hakAkses: {
      query: FIND,
      update(data) {
        return data.hakAksesByUuid;
      },
      variables() {
        return {
          uuid: this.$route.params.uuid
        };
      },
      fetchPolicy: "cache-and-network"
    },
    hakAksesPengguna: {
      query: GET_ALL,
      update: data => data.hakAksesPengguna,
      variables() {
        return {
          perPage: this.pagination.perPage,
          page: this.pagination.page,
          where: {
            column: "HAK_AKSES_ID",
            value: typeof this.hakAkses != "undefined" ? this.hakAkses.id : 1
          }
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  watch: {
    hakAkses: {
      handler() {
        if (this.hakAkses) {
          this.refetchHakAksesPengguna(1);
        }
      }
    }
  },
  methods: {
    setSelectedChild(index) {
      this.selectedChildData = this.hakAkses.child[index];
      this.$refs.dialogUpdateChild.toggleActive(true);
    },
    refetchHakAkses() {
      this.$apollo.queries.hakAkses.refetch();
    },
    refetchHakAksesPengguna(event) {
      this.pagination.page = event;
      this.$apollo.queries.hakAksesPengguna.refetch();
    }
  }
};
</script>
